import React from "react";
import styled from "styled-components";
import { brand } from "../../brand";
import { color, radius, shadow, fontFamily } from "../../Components/Theme";

// Shared shell for the pre-login pages. All colours come from the per-brand
// token set, so GPS Care keeps its own theme and TLScare gets the new one.
const Page = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  background-color: ${color("bg-color")};
  font-family: ${fontFamily()};
`;

const BrandPanel = styled.aside`
  display: none;
  @media (min-width: 960px) {
    flex: 0 0 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 48px;
    background: ${color("gradient-brand")};
  }
`;

const LogoTile = styled.div`
  background: #ffffff;
  border-radius: ${radius("card")}px;
  box-shadow: ${shadow("raised")};
  padding: 32px 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 200px;
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

const FormPanel = styled.main`
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  @media (min-width: 960px) {
    background: ${color("surface")};
    padding: 48px;
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 440px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${color("surface")};
  border-radius: ${radius("card")}px;
  box-shadow: ${shadow("card")};
  padding: 32px 24px;
  @media (min-width: 960px) {
    box-shadow: none;
    padding: 0;
  }
  a {
    color: ${color("primary")};
    font-weight: 600;
    text-decoration: none;
    &:hover,
    &:focus-visible {
      text-decoration: underline;
    }
  }
  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
`;

const MobileLogo = styled.img`
  width: 120px;
  height: auto;
  margin-bottom: 24px;
  @media (min-width: 960px) {
    display: none;
  }
`;

const Title = styled.h1`
  margin: 0 0 24px;
  width: 100%;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: ${color("heading")};
`;

export default function AuthLayout({ title, children }) {
  return (
    <Page>
      <BrandPanel>
        <LogoTile>
          <img src={brand.logo} alt="" />
        </LogoTile>
      </BrandPanel>
      <FormPanel>
        <MobileLogo src={brand.logo} alt="" />
        <Card>
          {title && <Title>{title}</Title>}
          {children}
        </Card>
      </FormPanel>
    </Page>
  );
}
